import { ErrorHandler, Injectable } from '@angular/core';
import { LoggingService } from '../service/logging.service';
import { serializeError } from './serialize-error';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(private logger: LoggingService) {}

    handleError(error: unknown): void {
        void this.logger.error('Unhandled error', serializeError(error));
    }
}
